import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";

import LoadingPage from "../../../services/LoadingPage";

import * as _ from "lodash";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import HeaderEn from "./A4/HeaderEn";
import BodyEn from "./A4/BodyEn";
import { sto } from "../../../Context/InshData";
import InvTotalsEn from "./A4/InvTotalsEn";

function BillPage(props) {
  // const { locInv, found, sta, inv, chunk } = props;
  const { locInv, found, sta, inv, chunk, isFirst, isLast, sum } = props;
  const clas = useInvAF();

  return (
    <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_page }}>
      <Fragment>
        {found.footer_img != null ?
          (
            <Grid xs={12} item style={{ ...stElemnt.AF.Reviws.pdf_bodyComany }}>
              <Grid xs={12} item >

                < HeaderEn locInv={locInv} info={found} sta={sta} inv={inv} />
                <BodyEn
                  data={chunk ?? []}
                  isFullPage={!isFirst ? true : false}
                  isLast={isLast}
                />

                <InvTotalsEn locInv={locInv} found={found} inv={inv} sta={sta ?? {}} />

              </Grid>
            </Grid>
          )
          :
          (
            <Grid xs={12} item >

              < HeaderEn locInv={locInv} info={found} sta={sta} inv={inv}  />
              <BodyEn
                data={chunk ?? []}
                isFullPage={!isFirst ? true : false}
                isLast={isLast}
              />
              <InvTotalsEn locInv={locInv} found={found} inv={inv} sta={sta ?? {}} />
            </Grid>
          )}

        <Grid xs={12} item style={{ maxHeight: "3.8cm", minHeight: "3.8cm" }}>
          {found.footer_img != null && (
            (
              <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                <div>
                  <ButtonBase>
                    {" "}
                    <img
                      src={`data:image/jpeg;base64,${found.footer_img}`}
                      className={clas.headerImg}
                      alt={found.nameA}
                    />{" "}
                  </ButtonBase>
                </div>
              </Grid>
            )
          )}
        </Grid>
      </Fragment>
    </Grid>
  );
}
function EnglishInvCon(props) {
  const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
  const [found, setFound] = useState({});
  const [sta, setSta] = useState({});
  const [inv, setInv] = useState({});
  const [loading, setLoading] = useState(true);
  const [chunks, setChunks] = useState([]);

  let count_id = 0;
  const getInfo = async () => {
    // alert('getInfo')
    const tb = {
      GetFoundation: true,
      Rpt_Inv: true,
      wait: true,
      parms: {
        lprocid: locInv.proc_id,
        ibranchid: sto.branchi,
        iFoundid: 1,
        branch: sto.branchi,
        sProcTypeInvProc: locInv.ProcTypeInvProc,
      },
      autos: {},
    };
    console.log(tb);
    await axios
      .post(`${uri}Res`, tb)
      .then((res) => {
        setSta({ info: res.data.RptInv, tot: res.data.infoBill });
        const data2 = res.data.RptInv.map((row, i) => {
          return {
            ...row,
            no: i + 1,
          };
        });
        setChunks(_.chunk(data2, 12));
        setFound(res.data.Found);
      })
      .catch((error) => {
        console.log("catch");
      });
  };
  const getInv = async () => {
    axios
      .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
      .then((res) => {
        console.log("the inve for fatoora", res.data);
        setInv(res.data);
      })
      .catch((error) => { });
  };
  useEffect(() => {
    setTimeout(async () => {
      await getInfo();
      await getInv();
      setLoading(false);
    }, 0);
  }, []);

  if (!found || !sta || loading) return <LoadingPage />;
  return (
    <Typography component="div" style={stElemnt.AF.Reviws.ReviwsJard}>
      <Typography component="div" >
        {chunks.map((page, i) => {
          return (
            <BillPage
              {...{
                locInv,
                found,
                sta,
                inv,
                chunk: page,
                isFirst: i == 0,
                isLast: i == chunks.length - 1,
              }}
            />
          );
        })}
      </Typography>
    </Typography>
  );
}
export default EnglishInvCon;
